import { S as SHORTEN_LENGTH, T as THEME, H as HOUR_IN_MS, D as DAY_IN_MS, W as WEEK_IN_MS, M as MONTH_IN_MS, Y as YEAR_IN_MS, a as MAX_TTL_TEMP, b as MAX_TTL_USER } from "./defaults.js";
import { nanoid } from "nanoid";
import * as v from "valibot";
import { safeParseAsync } from "valibot";
import { g as getLocale, t as trackMessageCall } from "./runtime.js";
import { p as public_env } from "./shared-server.js";
import dns from "node:dns/promises";
import { c as schemaInfo, S as SuperFormError, d as schemaShape, e as defaultValues } from "./formData.js";
import { merge as merge$1 } from "ts-deepmerge";
import baseMemoize from "memoize-weak";
import { toJSONSchema } from "@gcornut/valibot-json-schema";
const en_error_empty_key = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Please enter key`;
  }
);
const de_error_empty_key = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Ein Code wird benötigt`;
  }
);
const sp_error_empty_key = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Se necesita un código`;
  }
);
const error_empty_key = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("error_empty_key", locale);
  if (locale === "en") return en_error_empty_key();
  if (locale === "de") return de_error_empty_key();
  return sp_error_empty_key();
};
const en_error_invalid_email = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Please enter a valid e-mail`;
  }
);
const de_error_invalid_email = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Bitte gebe eine gültige E-Mail-Adresse ein`;
  }
);
const sp_error_invalid_email = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Por favor, introduce una dirección de correo electrónico válida`;
  }
);
const error_invalid_email = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("error_invalid_email", locale);
  if (locale === "en") return en_error_invalid_email();
  if (locale === "de") return de_error_invalid_email();
  return sp_error_invalid_email();
};
const en_error_link_min_lenght = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `We require links with a min length of ${i.requirement}`;
  }
);
const de_error_link_min_lenght = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `Wir benötigen Links mit einer Mindestlänge von ${i.requirement}`;
  }
);
const sp_error_link_min_lenght = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `Necesitamos enlaces con una longitud mínima de ${i.requirement}`;
  }
);
const error_link_min_lenght = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("error_link_min_lenght", locale);
  if (locale === "en") return en_error_link_min_lenght(inputs);
  if (locale === "de") return de_error_link_min_lenght(inputs);
  return sp_error_link_min_lenght(inputs);
};
const en_error_invalid_url = (
  /** @type {(inputs: { received: NonNullable<unknown> }) => string} */
  (i) => {
    return `Please enter a valid URL. We reciefed: ${i.received}`;
  }
);
const de_error_invalid_url = (
  /** @type {(inputs: { received: NonNullable<unknown> }) => string} */
  (i) => {
    return `Bitte gebe eine gültige URL ein. Aktuell: ${i.received}`;
  }
);
const sp_error_invalid_url = (
  /** @type {(inputs: { received: NonNullable<unknown> }) => string} */
  (i) => {
    return `Por favor, introduce una URL válida. Actual: ${i.received}`;
  }
);
const error_invalid_url = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("error_invalid_url", locale);
  if (locale === "en") return en_error_invalid_url(inputs);
  if (locale === "de") return de_error_invalid_url(inputs);
  return sp_error_invalid_url(inputs);
};
const en_invalid_maxvalue1 = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `Maximal value is ${i.requirement}`;
  }
);
const de_invalid_maxvalue1 = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `Maximalwert ${i.requirement}`;
  }
);
const sp_invalid_maxvalue1 = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `El valor máximo es ${i.requirement}`;
  }
);
const invalid_maxvalue1 = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("invalid_maxvalue1", locale);
  if (locale === "en") return en_invalid_maxvalue1(inputs);
  if (locale === "de") return de_invalid_maxvalue1(inputs);
  return sp_invalid_maxvalue1(inputs);
};
const en_invalid_number = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Allow only numbers`;
  }
);
const de_invalid_number = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Nur Nummern erlaubt`;
  }
);
const sp_invalid_number = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Solo se permiten números`;
  }
);
const invalid_number = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("invalid_number", locale);
  if (locale === "en") return en_invalid_number();
  if (locale === "de") return de_invalid_number();
  return sp_invalid_number();
};
const en_invalid_private_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Private links are not allowed!`;
  }
);
const de_invalid_private_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Private links sind nicht erlaubt!`;
  }
);
const sp_invalid_private_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `No se permiten enlaces privados!`;
  }
);
const invalid_private_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("invalid_private_link", locale);
  if (locale === "en") return en_invalid_private_link();
  if (locale === "de") return de_invalid_private_link();
  return sp_invalid_private_link();
};
const sp_invalid_minvlaue1 = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `El valor mínimo es ${i.requirement}`;
  }
);
const en_invalid_minvlaue1 = () => "invalid_minVlaue";
const de_invalid_minvlaue1 = en_invalid_minvlaue1;
const invalid_minvlaue1 = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("invalid_minvlaue1", locale);
  if (locale === "en") return en_invalid_minvlaue1();
  if (locale === "de") return de_invalid_minvlaue1();
  return sp_invalid_minvlaue1(inputs);
};
const isPrivateIPv4 = (ip) => isIPv4InRange(ip, "10.0.0.0", 8) || isIPv4InRange(ip, "172.16.0.0", 12) || isIPv4InRange(ip, "192.168.0.0", 16) || isIPv4InRange(ip, "169.254.0.0", 16) || isIPv4InRange(ip, "127.0.0.0", 8) || isIPv4InRange(ip, "100.64.0.0", 10) || isIPv4InRange(ip, "169.254.0.0", 16) || isIPv4InRange(ip, "0.0.0.0", 8);
const isPrivateIPv6 = (ip) => isIPv6InRange(ip, "::1", 128) || isIPv6InRange(ip, "fe80::", 10) || isIPv6InRange(ip, "fc00::", 7) || isIPv6InRange(ip, "fec0::", 10);
const isPublicLink = async (link) => {
  const { hostname } = new URL(link);
  const records = await dns.lookup(hostname, { all: true });
  for (const record of records) {
    if (record.family === 4) {
      return !isPrivateIPv4(record.address);
    }
    if (record.family === 6) {
      return !isPrivateIPv6(record.address);
    }
  }
  return false;
};
const ipv4ToHex = (ip) => ip.split(".").map((part) => parseInt(part, 10)).reduce((acc, part, index) => acc + part * Math.pow(256, 3 - index), 0);
const isIPv4InRange = (ip, ipNet, subnetSize) => {
  const ipHex = ipv4ToHex(ip) >>> 32 - subnetSize;
  const netHex = ipv4ToHex(ipNet) >>> 32 - subnetSize;
  return ipHex === netHex;
};
const isIPv4 = (ip) => {
  const split = ip.split(".");
  return split.length === 4 && split.every((part) => parseInt(part, 10) >= 0 && parseInt(part, 10) <= 255);
};
const isIPv6 = (ip) => {
  const split = ip.split(":");
  return split.length >= 2 && split.every((part) => part === "" || part.length <= 4 && /^[0-9a-fA-F]+$/.test(part));
};
const ipv6ToHex = (ip) => ip.split(":").reduce((acc, part, index, arr) => {
  if (part === "" && index !== arr.length - 1) {
    const missingParts = 8 - (arr.length - 1);
    for (let i = 0; i < missingParts; i++) {
      acc.push(0);
    }
  } else if (part === "") {
    acc.push(0);
  } else {
    acc.push(parseInt(part, 16));
  }
  return acc;
}, []).reduce((acc, part, index) => acc + part * Math.pow(65536, 7 - index), 0);
const isIPv6InRange = (ip, ipNet, subnetSize) => {
  const hexPositions = Math.ceil(subnetSize / 8);
  let mask = 0;
  for (let i = 0; i < hexPositions * 8; i++) {
    mask = mask << 1;
    if (i < subnetSize) {
      mask += 1;
    }
  }
  const ipHex = ipv6ToHex(ip).toString(16).slice(0, hexPositions);
  const netHex = ipv6ToHex(ipNet).toString(16).slice(0, hexPositions);
  return (parseInt(ipHex, 16) & mask) === (parseInt(netHex, 16) & mask);
};
const getString = (value, defaultValue) => {
  if (value != null) {
    const string = String(value);
    return string;
  }
  throw new Error("Value is required");
};
const TTLs = [
  [HOUR_IN_MS, "anhour"],
  [DAY_IN_MS, "aday"],
  [WEEK_IN_MS, "aweek"],
  [MONTH_IN_MS, "amonth"],
  [YEAR_IN_MS, "ayear"]
];
const emptyStringToNull = (str) => str?.trim() === "" ? null : str;
function ttlFromStep(step) {
  if (!step) {
    return void 0;
  }
  return TTLs[step][0];
}
const ttlMapFromStep = (step) => {
  if (step === void 0) {
    return TTLs;
  }
  return TTLs.slice(0, step + 1);
};
const getTTLTempUser = () => ttlMapFromStep(MAX_TTL_TEMP);
const getTTLUser = () => ttlMapFromStep(MAX_TTL_USER);
const getTTLs = (loggedin) => loggedin ? getTTLUser() : getTTLTempUser();
const couldTLLInfinit = (loggedin) => (loggedin ? MAX_TTL_USER : MAX_TTL_TEMP) === void 0;
const LinkValueSchema = v.pipe(
  v.string(),
  v.trim(),
  v.minLength(2, error_link_min_lenght),
  v.transform((url) => url.match(/^[A-Za-z]+:\/\//) ? url : `https://${url}`),
  v.url(error_invalid_url),
  v.custom((value) => {
    if (public_env.PUBLIC_FEATURE_PRIVATE_LINKS !== "on" && typeof value === "string") {
      const { hostname } = new URL(value);
      if (isIPv4(hostname)) {
        return !isPrivateIPv4(hostname);
      } else if (isIPv6(hostname)) {
        return !isPrivateIPv6(hostname);
      }
    }
    return true;
  }, invalid_private_link)
);
const LinkSchemaBase = v.object({
  link: LinkValueSchema,
  passphrase: v.optional(v.pipe(v.string(), v.trim())),
  callLimit: v.optional(
    v.pipe(v.number(invalid_number), v.integer(), v.minValue(1, invalid_minvlaue1))
  ),
  short: v.pipe(
    v.fallback(v.pipe(v.string(), v.trim(), v.minLength(1)), () => nanoid(SHORTEN_LENGTH))
  )
});
const getMaxValueValidator = (step) => {
  const maxValue = ttlFromStep(step);
  const errorMessage = maxValue ? () => /* @__PURE__ */ invalid_maxvalue1({ requirement: maxValue }) : "";
  return v.custom((input) => {
    if (!maxValue) {
      return true;
    }
    if (typeof input === "number") {
      return input <= maxValue;
    }
    return false;
  }, errorMessage);
};
const LinkSchemaSignedUp = v.object({
  ...LinkSchemaBase.entries,
  ttl: v.pipe(
    v.optional(v.pipe(v.number()), ttlFromStep(MAX_TTL_USER)),
    getMaxValueValidator(MAX_TTL_USER)
  )
});
const LinkSchemaTemp = v.object({
  ...LinkSchemaBase.entries,
  ttl: v.pipe(v.optional(v.number(), ttlFromStep(MAX_TTL_TEMP)), getMaxValueValidator(MAX_TTL_TEMP))
});
const getLinkSchema = (loggedin) => loggedin ? LinkSchemaSignedUp : LinkSchemaTemp;
const PassphraseSchema = v.object({
  passphrase: v.pipe(v.string(), v.trim(), v.minLength(1))
});
const LoginMailSchema = v.object({
  email: v.pipe(v.string(), v.trim(), v.email(error_invalid_email)),
  theme: v.optional(v.pipe(v.number(), v.enum(THEME)))
});
const VerificationSchema = v.object({
  key: v.pipe(v.string(), v.trim(), v.minLength(1, error_empty_key), v.toLowerCase())
});
const ThemeSchema = v.object({
  theme: v.optional(v.pipe(v.number(), v.enum(THEME)))
});
const memoize = baseMemoize;
function constraints(schema) {
  return _constraints(schemaInfo(schema, false, []), []);
}
function merge(...constraints2) {
  const filtered = constraints2.filter((c) => !!c);
  if (!filtered.length)
    return void 0;
  if (filtered.length == 1)
    return filtered[0];
  return merge$1(...filtered);
}
function _constraints(info, path) {
  if (!info)
    return void 0;
  let output = void 0;
  if (info.union && info.union.length) {
    const infos = info.union.map((s) => schemaInfo(s, info.isOptional, path));
    const merged = infos.map((i) => _constraints(i, path));
    output = merge(output, ...merged);
    if (output && (info.isNullable || info.isOptional || infos.some((i) => i?.isNullable || i?.isOptional))) {
      delete output.required;
    }
  }
  if (info.array) {
    output = merge(output, ...info.array.map((i) => _constraints(schemaInfo(i, info.isOptional, path), path)));
  }
  if (info.properties) {
    const obj = {};
    for (const [key, prop] of Object.entries(info.properties)) {
      const propInfo = schemaInfo(prop, !info.required?.includes(key) || prop.default !== void 0, [key]);
      const propConstraint = _constraints(propInfo, [...path, key]);
      if (typeof propConstraint === "object" && Object.values(propConstraint).length > 0) {
        obj[key] = propConstraint;
      }
    }
    output = merge(output, obj);
  }
  return output ?? constraint(info);
}
function constraint(info) {
  const output = {};
  const schema = info.schema;
  const type = schema.type;
  const format = schema.format;
  if (type == "integer" && format == "unix-time") {
    const date = schema;
    if (date.minimum !== void 0)
      output.min = new Date(date.minimum).toISOString();
    if (date.maximum !== void 0)
      output.max = new Date(date.maximum).toISOString();
  } else if (type == "string") {
    const str = schema;
    const patterns = [
      str.pattern,
      ...str.allOf ? str.allOf.map((s) => typeof s == "boolean" ? void 0 : s.pattern) : []
    ].filter((s) => s !== void 0);
    if (patterns.length > 0)
      output.pattern = patterns[0];
    if (str.minLength !== void 0)
      output.minlength = str.minLength;
    if (str.maxLength !== void 0)
      output.maxlength = str.maxLength;
  } else if (type == "number" || type == "integer") {
    const num = schema;
    if (num.minimum !== void 0)
      output.min = num.minimum;
    else if (num.exclusiveMinimum !== void 0)
      output.min = num.exclusiveMinimum + (type == "integer" ? 1 : Number.MIN_VALUE);
    if (num.maximum !== void 0)
      output.max = num.maximum;
    else if (num.exclusiveMaximum !== void 0)
      output.max = num.exclusiveMaximum - (type == "integer" ? 1 : Number.MIN_VALUE);
    if (num.multipleOf !== void 0)
      output.step = num.multipleOf;
  } else if (type == "array") {
    const arr = schema;
    if (arr.minItems !== void 0)
      output.min = arr.minItems;
    if (arr.maxItems !== void 0)
      output.max = arr.maxItems;
  }
  if (!info.isNullable && !info.isOptional) {
    output.required = true;
  }
  return Object.keys(output).length > 0 ? output : void 0;
}
function schemaHash(schema) {
  return hashCode(_schemaHash(schemaInfo(schema, false, []), 0, []));
}
function _schemaHash(info, depth, path) {
  if (!info)
    return "";
  function tab() {
    return "  ".repeat(depth);
  }
  function mapSchemas(schemas) {
    return schemas.map((s) => _schemaHash(schemaInfo(s, info?.isOptional ?? false, path), depth + 1, path)).filter((s) => s).join("|");
  }
  function nullish() {
    const output = [];
    if (info?.isNullable)
      output.push("null");
    if (info?.isOptional)
      output.push("undefined");
    return !output.length ? "" : "|" + output.join("|");
  }
  if (info.union) {
    return "Union {\n  " + tab() + mapSchemas(info.union) + "\n" + tab() + "}" + nullish();
  }
  if (info.properties) {
    const output = [];
    for (const [key, prop] of Object.entries(info.properties)) {
      const propInfo = schemaInfo(prop, !info.required?.includes(key) || prop.default !== void 0, [key]);
      output.push(key + ": " + _schemaHash(propInfo, depth + 1, path));
    }
    return "Object {\n  " + tab() + output.join(",\n  ") + "\n" + tab() + "}" + nullish();
  }
  if (info.array) {
    return "Array[" + mapSchemas(info.array) + "]" + nullish();
  }
  return info.types.join("|") + nullish();
}
function hashCode(str) {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  if (hash < 0)
    hash = hash >>> 0;
  return hash.toString(36);
}
// @__NO_SIDE_EFFECTS__
function createAdapter(adapter, jsonSchema) {
  if (!adapter || !("superFormValidationLibrary" in adapter)) {
    throw new SuperFormError('Superforms v2 requires a validation adapter for the schema. Import one of your choice from "sveltekit-superforms/adapters" and wrap the schema with it.');
  }
  if (!jsonSchema)
    jsonSchema = adapter.jsonSchema;
  return {
    ...adapter,
    constraints: adapter.constraints ?? constraints(jsonSchema),
    defaults: adapter.defaults ?? defaultValues(jsonSchema),
    shape: schemaShape(jsonSchema),
    id: schemaHash(jsonSchema)
  };
}
const defaultOptions = {
  strictObjectTypes: true,
  dateStrategy: "integer",
  bigintStrategy: "integer",
  ignoreUnknownValidation: true,
  customSchemaConversion: {
    custom: () => ({}),
    instance: () => ({}),
    file: () => ({}),
    blob: () => ({})
  }
};
const valibotToJSONSchema = /* @__NO_SIDE_EFFECTS__ */ (options) => {
  return toJSONSchema({ ...defaultOptions, ...options });
};
async function _validate(schema, data, config) {
  const result = await safeParseAsync(schema, data, config);
  if (result.success) {
    return {
      data: result.output,
      success: true
    };
  }
  return {
    issues: result.issues.map(({ message, path }) => ({
      message,
      path: path?.map(({ key }) => key)
    })),
    success: false
  };
}
function _valibot(schema, options = {}) {
  return /* @__PURE__ */ createAdapter({
    superFormValidationLibrary: "valibot",
    validate: async (data) => _validate(schema, data, options?.config),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    jsonSchema: options?.jsonSchema ?? /* @__PURE__ */ valibotToJSONSchema({ schema, ...options }),
    defaults: "defaults" in options ? options.defaults : void 0
  });
}
function _valibotClient(schema, options = {}) {
  return {
    superFormValidationLibrary: "valibot",
    validate: async (data) => _validate(schema, data, options?.config)
  };
}
const valibot = /* @__PURE__ */ memoize(_valibot);
const valibotClient = /* @__PURE__ */ memoize(_valibotClient);
export {
  LoginMailSchema as L,
  PassphraseSchema as P,
  ThemeSchema as T,
  VerificationSchema as V,
  error_invalid_email as a,
  error_invalid_url as b,
  error_link_min_lenght as c,
  invalid_minvlaue1 as d,
  error_empty_key as e,
  invalid_number as f,
  invalid_private_link as g,
  getTTLs as h,
  invalid_maxvalue1 as i,
  getLinkSchema as j,
  couldTLLInfinit as k,
  valibot as l,
  getString as m,
  isPublicLink as n,
  emptyStringToNull as o,
  valibotClient as v
};
